import PubSub from "underpub-js";
import Slick from "slick-carousel";
import Equalizer from "../../../../scripts/classes/Equalizer";

var ListingAwardsSlider = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-ListingAwardsSlider',
	};

	$.extend(true, this.options, options);

};

ListingAwardsSlider.prototype.init = function() {

	var self = this;

	this.$awardsSlider = this.options.$el.find(`.${self.options.baseClass}__awardsSlider`);

	this.$awardsSlider.on('init', function(slick) {
		// create the slide equalizer here, so that it detects clones that are created
		self.slideEq = new Equalizer( self.options.$el.find(`.${self.options.baseClass}__slide`) );
		self.slideEq.equalizeHeights();
	});

	PubSub.subscribe("resized", function() {
		// re-initializing the equalizer here fixes a bug where cloned slides weren't getting properly equalized
		self.slideEq = new Equalizer( self.options.$el.find(`.${self.options.baseClass}__slide`) );
		self.slideEq.equalizeHeights();
	});

	// initialize card slider
	this.$awardsSlider.slick({
		arrows: false,
		fade: false,
		speed: 750,
		slidesToShow: 4,
		swipeToSlide: true,
		infinite: true,
		centerMode: false,
		centerPadding: '11%',

		responsive: [

			{
				breakpoint: 1740,
				settings: {
					slidesToShow: 4,
					centerPadding: '11%',
				}
			},
			{
				breakpoint: 1620,
				settings: {
					slidesToShow: 4,
					centerPadding: '8%',
				}
			},
			{
				breakpoint: 1500,
				settings: {
					slidesToShow: 4,
					centerPadding: '4%',
				}
			},
			{
				breakpoint: 1340,
				settings: {
					slidesToShow: 3,
					centerPadding: '15%',
				}
			},
			{
				breakpoint: 1100,
				settings: {
					slidesToShow: 3,
					centerPadding: '12%',
				}
			},
			{
				breakpoint: 960,
				settings: {
					slidesToShow: 3,
					centerPadding: '8%',
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					centerPadding: '25%',
				}
			},
			{
				breakpoint: 620,
				settings: {
					slidesToShow: 2,
					centerPadding: '22%',
				}
			},
			{
				breakpoint: 540,
				settings: {
					slidesToShow: 2,
					centerPadding: '18%',
				}
			},
			{
				breakpoint: 460,
				settings: {
					slidesToShow: 2,
					centerPadding: '12%',
				}
			},
			{
				breakpoint: 400,
				settings: {
					slidesToShow: 1,
					centerPadding: '6%',
				}
			}

		]


	});

	// previous/next buttons
	this.options.$el.find(`.${self.options.baseClass}__sliderButton--previous`).on('click', function() {
		self.$awardsSlider.slick('slickPrev');
	});

	this.options.$el.find(`.${self.options.baseClass}__sliderButton--next`).on('click', function() {
		self.$awardsSlider.slick('slickNext');
	});

};

export default ListingAwardsSlider;
